// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 76978) return "static/chunks/" + chunkId + "-b4b5d6606a79d524.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "590a2aad0272bba0" + ".js";
};